import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { supabase } from '@/lib/supabase'

/**
 * «Be om ny lenke» for whoever holds a dead link (task 9's `request_link_reissue`).
 *
 * The last segment of the address is sent as the token. A known and an unknown token get the
 * same answer, so the endpoint cannot be used to test whether a token exists; the ask lands on
 * the organiser's list and NOTHING is sent until she acts. Was inline in `NotFound`; shared since
 * 03.10.2026 so every dead token page offers it, not only the 404 (re-score: four dead-end pages
 * had no exit at all).
 */
export function useRequestNewLink() {
  const { pathname } = useLocation()
  const [asking, setAsking] = useState(false)
  const [asked, setAsked] = useState(false)
  const request = async () => {
    setAsking(true)
    const candidate = pathname.split('/').filter(Boolean).pop() ?? ''
    const { error } = await supabase.rpc('request_link_reissue', { p_token: candidate })
    setAsking(false)
    // Told the same either way: a failure must not become a second dead end.
    void error
    setAsked(true)
  }
  return { asking, asked, request }
}
